import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';

import { GenericField, IGenericField } from 'libraries/module/formbuilder/fields/generic-field';
import { FormBuilderService } from "libraries/service/formBuilder/formBuilder.service";
import { IFieldSpecs } from '../interfaces/field-specs';


/**
 * Date-field
 * Generate date field with calendar
 * @extends GenericField
 * @deprecated use ComboboxFieldComponent instead
 */
@Component({
    selector: 'dropdown-field',
    templateUrl: './dropdown-field.component.html',
    styleUrls: ['./dropdown-field.scss'],
})
export class DropdownFieldComponent extends GenericField implements IGenericField, OnInit, OnDestroy {
    public focusEmit: EventEmitter<boolean> = new EventEmitter();

    public fieldConfig: IFieldSpecs;

    constructor(private formBuilderService: FormBuilderService) {
        super();
    }

    public ngOnInit(): void{
        this.fieldConfig = {
            formGroup: this.group,
            formControlName: this.controlName,
            label: this.label,
            validators: this.validators.length ? this.validators : null,
        };

        this.subscription = this.formBuilderService
            .focusEvent
            .subscribe(
                (_focusName: any) => {
                    if (this.focusName && _focusName === this.focusName) {
                        this.focusEmit.emit(true);
                    }
                });
    }

    public ngOnDestroy(): void{
        this.subscription.unsubscribe();
    }
}
